var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { addDays, endOfDay, isSameDay, startOfDay, fromUnixTime } from 'date-fns';
import { DeskStatusEnum } from 'employee-schedule/graphql/generated/graphql-types';
import changeDeskReservationMutation from 'employee-schedule/graphql/mutations/ChangeDeskReservationMutation';
import checkInReservationMutation from 'employee-schedule/graphql/mutations/CheckInReservationMutation';
import createInviteReservationMutation from 'employee-schedule/graphql/mutations/CreateInviteReservationMutation';
import deleteInviteMutation from 'employee-schedule/graphql/mutations/DeleteInviteMutation';
import deleteInviteReservationMutation from 'employee-schedule/graphql/mutations/DeleteInviteReservationMutation';
import deleteInviteReservationsMutation from 'employee-schedule/graphql/mutations/DeleteInviteReservationsMutation';
import releaseDeskReservationMutation from 'employee-schedule/graphql/mutations/ReleaseDeskReservationMutation';
import signInInviteMutation from 'employee-schedule/graphql/mutations/SignInInviteMutation';
import signOutEntryMutation from 'employee-schedule/graphql/mutations/SignOutEntryMutation';
import signOutEntryReservationMutation from 'employee-schedule/graphql/mutations/SignOutEntryReservationMutation';
import availableDesksForLocationQuery from 'employee-schedule/graphql/queries/AvailableDesksForLocationQuery';
import desksOnFloorForLocationQuery from 'employee-schedule/graphql/queries/DesksOnFloorForLocationQuery';
import employeeRegistrationQuery from 'employee-schedule/graphql/queries/EmployeeRegistrationDatesQuery';
import employeeRegistrationPartialDayQuery from 'employee-schedule/graphql/queries/EmployeeRegistrationPartialDayQuery';
import reservationByIdQuery from 'employee-schedule/graphql/queries/ReservationByIdQuery';
import { DEFAULT_FLOW_NAME } from 'garaje/utils/enums';
let GraphqlService = (_class = class GraphqlService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "apolloExtension", _descriptor, this);
    _initializerDefineProperty(this, "state", _descriptor2, this);
    _initializerDefineProperty(this, "workplaceMetrics", _descriptor3, this);
  }
  isDbeamEnabled() {
    // TODO: replace with feature flag service
    return false;
  }
  async fetchRegistrations({
    startDate,
    length = 30
  }) {
    const {
      id: locationId
    } = this.state.currentLocation;
    const variables = {
      includeEmployeeInvite: this.isDbeamEnabled(),
      locationId,
      startDate,
      endDate: addDays(startDate, length - 1)
    };
    try {
      return await this.apolloExtension.query({
        query: employeeRegistrationQuery,
        variables
      }, 'employeeRegistration');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_FETCHING_REGISTRATIONS',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }
  async fetchPartialDayRegistrations({
    startDate,
    length = 30
  }) {
    const {
      id: locationId
    } = this.state.currentLocation;
    const variables = {
      includeEmployeeInvite: this.isDbeamEnabled(),
      locationId,
      startDate,
      endDate: addDays(startDate, length - 1)
    };
    try {
      return await this.apolloExtension.query({
        query: employeeRegistrationPartialDayQuery,
        variables: variables
      }, 'employeeRegistrationPartialDay');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_FETCHING_PARTIAL_DAY_REGISTRATIONS',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   *  Changes a desk reservation to a new desk
   */
  async changeDesk({
    currentDeskId,
    newDeskId,
    reservationId
  }) {
    const variables = {
      currentDeskID: currentDeskId,
      newDeskID: newDeskId,
      reservationID: reservationId
    };
    try {
      return await this.apolloExtension.mutate({
        mutation: changeDeskReservationMutation,
        variables: variables
      }, 'changeDeskReservation');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_CHANGING_DESK',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *   reservationId: Number    Required
   * }
   * Checks in a desk reservation
   */
  async checkInReservation({
    reservationId
  }) {
    const variables = {
      reservationID: reservationId
    };
    try {
      return await this.apolloExtension.mutate({
        mutation: checkInReservationMutation,
        variables: variables
      }, 'checkInReservation');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_CHECKING_IN_RESERVATION',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *   inviteId: Number         Required
   *   reservationId: Number    Optional
   * }
   *
   * Unscheduling releases a desk reservation and also deletes the invite
   */
  async unschedule({
    reservationId,
    inviteId
  }) {
    const variables = reservationId ? {
      inviteId,
      reservationId
    } : {
      inviteId
    };
    try {
      if (reservationId) {
        return await this.apolloExtension.mutate({
          mutation: deleteInviteReservationMutation,
          variables: variables
        }, 'deleteInviteReservation');
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return await this.apolloExtension.mutate({
          mutation: deleteInviteMutation,
          variables: variables
        }, 'deleteInvite');
      }
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_UNSCHEDULING',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *   inviteId: Number                     Required
   *   reservationIds: Array of numbers     Optional
   * }
   *
   * Unscheduling releases a desk reservation and also deletes the invite
   */
  async unschedulePartialDay({
    reservationIds = [],
    inviteId
  }) {
    const variables = {
      inviteId,
      reservationIds
    };
    try {
      return await this.apolloExtension.mutate({
        mutation: deleteInviteReservationsMutation,
        variables: variables
      }, 'deleteInviteReservations');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_UNSCHEDULING_PARTIAL_DAY',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * Releasing a desk does not delete the invite
   */
  async releaseDeskReservation({
    reservationId
  }) {
    try {
      return await this.apolloExtension.mutate({
        mutation: releaseDeskReservationMutation,
        variables: {
          reservationId
        }
      }, 'releaseDeskReservation');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_RELEASING_DESK_RESERVATION',
        debugExtras: {
          reservationId
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *   date: Date     Required
   * }
   *
   * Releasing a desk does not delete the invite
   */
  // When using `this.moment.utc(date)`, many timezones (all except Pacific, Alaska, and Samoa) will include desks for two different days (the correct day and the day before).
  // However, when using `this.moment.moment(date)`, those timezones will only return one day... the wrong one (the day before the selected day).
  // There is probably a solution that solves this more precisely, and I encourage others to look for it.
  async fetchRegistrationByDate({
    date
  }) {
    const {
      id: locationId
    } = this.state.currentLocation;
    const variables = {
      includeEmployeeInvite: this.isDbeamEnabled(),
      locationId,
      startDate: startOfDay(date),
      endDate: endOfDay(date)
    };
    try {
      const response = await this.apolloExtension.query({
        query: employeeRegistrationQuery,
        variables: variables
      }, 'employeeRegistration');
      return response.registrationDates?.find(rd => isSameDay(rd.date, date));
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_FETCHING_REGISTRATION_BY_DATE',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }
  async fetchPartialDayRegistrationByDate({
    date
  }) {
    const {
      id: locationId
    } = this.state.currentLocation;
    const variables = {
      includeEmployeeInvite: this.isDbeamEnabled(),
      locationId,
      startDate: startOfDay(date),
      endDate: endOfDay(date)
    };
    try {
      const response = await this.apolloExtension.query({
        query: employeeRegistrationPartialDayQuery,
        variables: variables
      }, 'employeeRegistrationPartialDay');
      return response.registrationDates?.find(rd => isSameDay(rd.date, date));
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_FETCHING_PARTIAL_DAY_REGISTRATION_BY_DATE',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }
  /**
   * @param {Object}  {
   *  date: Date    Required
   * }
   * @returns {Array<gqlDesk>}  List of graphql desks
   *
   * Releasing a desk does not delete the invite
   */
  async fetchAvailableDesks({
    date
  }) {
    const {
      id: locationId
    } = this.state.currentLocation;
    const variables = {
      locationId,
      date: date
    };
    try {
      return await this.apolloExtension.query({
        query: availableDesksForLocationQuery,
        fetchPolicy: 'network-only',
        variables: variables
      }, 'availableDesksForLocation');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_FETCHING_AVAILABLE_DESKS',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *  date: Date    Required
   * }
   * * @param {Object}  {
   *  floorId: Number    Required
   * }
   * @returns {Array<gqlDesk>}  List of graphql desks
   *
   * Releasing a desk does not delete the invite
   */
  async fetchAvailableDesksWithAmenities({
    reservation,
    floorId
  }) {
    const {
      id: locationId
    } = this.state.currentLocation;
    const variables = {
      locationId,
      // for some reason this was working before
      floorId: floorId,
      startTime: fromUnixTime(reservation.startTime),
      endTime: fromUnixTime(reservation.endTime),
      filters: [DeskStatusEnum.Available]
    };
    try {
      const queryResponse = await this.apolloExtension.query({
        query: desksOnFloorForLocationQuery,
        fetchPolicy: 'network-only',
        variables: variables
      }, 'desksOnFloorForLocation');
      return queryResponse.desks;
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_FETCHING_AVAILABLE_DESKS_WITH_AMENITIES',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *  entryId:        Number    Required
   *  signedOutAt:  Date        Required
   *  reservationId:  Number    Optional
   *
   * @returns {gqlEntry}  Graphql representation of an entry
   *
   * Sign out an entry
   */
  async signOutEntry({
    entryId,
    reservationId,
    signedOutAt
  }) {
    const variables = reservationId ? {
      id: entryId,
      reservationId,
      signedOutAt
    } : {
      id: entryId,
      signedOutAt
    };
    try {
      if (reservationId) {
        return await this.apolloExtension.mutate({
          mutation: signOutEntryReservationMutation,
          variables: variables
        }, 'signOutEntry');
      } else {
        return await this.apolloExtension.mutate({
          mutation: signOutEntryMutation,
          variables: variables
        }, 'signOutEntry');
      }
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_SIGNING_OUT_ENTRY',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *  inviteId:       Number        Required
   *  reservationId:  Number        Optional
   * }
   *
   * @returns {gqlEntry}  Graphql representation of an entry
   *
   * Signing in an invite returns an entry
   */
  async signInInvite({
    inviteId,
    reservationId
  }) {
    const variables = {
      inviteID: inviteId,
      reservationId
    };
    try {
      return await this.apolloExtension.mutate({
        mutation: signInInviteMutation,
        variables: variables
      }, 'signInInvite');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_SIGNING_IN_INVITE',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }

  /**
   * @param {Object}  {
   *   date: Date
   *   inviteId: Number
   *   deskId: Number
   * }
   *
   * Creates a desk reservation and invite
   * This is the v2 endpoint. trying to move to this
   */
  async createInviteReservation({
    screeningCard,
    inviteId = null,
    deskId = null
  }) {
    const {
      currentUser,
      currentLocation
    } = this.state;
    const {
      id: location
    } = currentLocation;
    const variables = {
      includeEmployeeInvite: this.isDbeamEnabled(),
      ...(inviteId ? {
        inviteId
      } : {}),
      ...(deskId ? {
        deskId
      } : {}),
      ...(!inviteId ? {
        invite: {
          fullName: currentUser.fullName,
          email: currentUser.email,
          location,
          userData: [{
            field: 'Purpose of visit',
            value: DEFAULT_FLOW_NAME.EMPLOYEE_SCREENING
          }],
          expectedArrivalTime: screeningCard.expectedArrivalTime
        }
      } : {})
    };
    try {
      return await this.apolloExtension.mutate({
        mutation: createInviteReservationMutation,
        variables: variables
      }, 'createInviteReservation');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_CREATING_INVITE_RESERVATION',
        debugExtras: {
          variables
        },
        error: e
      });
      throw e;
    }
  }
  async fetchReservationById({
    reservationId
  }) {
    try {
      return await this.apolloExtension.query({
        query: reservationByIdQuery,
        variables: {
          reservationId
        }
      }, 'reservationById');
    } catch (e) {
      this.workplaceMetrics.logMonitorError({
        event: 'ERROR_FETCHING_RESERVATION_BY_ID',
        debugExtras: {
          reservationId
        },
        error: e
      });
      throw e;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "apolloExtension", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "workplaceMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { GraphqlService as default };